import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    // Use state to manage the mobile menu's open/closed state
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    // Function to toggle the menu state
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    
    // UPDATED: The tracker is at the root path of this app (/)
    const isTrackerActive = location.pathname === '/';

    return (
        <header className="header">
            <div className="container">
                <div className="logo-container">
                    <a href="https://danwilliamsforcongress.com/">
                        <img src={`${process.env.PUBLIC_URL}/checkMarkLogo.svg`} alt="Dan Williams For Congress Logo" className="logo" />
                    </a>
                </div>

                <div className="main-nav desktop-only">
                    <nav className="nav-links">
                        <ul>
                            <li>
                                <a href="https://danwilliamsforcongress.com/">Homepage</a>
                            </li>
                            <li>
                                {/* NEW EXTERNAL LINK: Points to the separate video application */}
                                <a href="https://danwilliamsforcongress.com/videos">Videos</a>
                            </li>
                            <li>
                                    <a href="https://danwilliamsforcongress.com/blog.html">News/Updates</a>
                            </li>
                            <li>
                                <a href="https://danwilliamsforcongress.com/tech-tools.html">Tech Tools</a>
                            </li>
                        </ul>
                    </nav>
                    <a href="https://danwilliamsforcongress.com/contact-page" className="contact-button">
                        Contact us
                    </a>
                </div>

                {!isMenuOpen && (
                    <button className="hamburger-menu-icon" onClick={toggleMenu}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="white">
                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
                        </svg>
                    </button>
                )}
                {isMenuOpen && (
                    <button className="close-menu-icon" onClick={toggleMenu}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="white">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                )}
            </div>
            
            {isMenuOpen && (
                <div className="mobile-menu">
                    <div className="mobile-menu-content">
                        <nav className="mobile-nav-links">
                            <ul>
                                <li>
                                    <a href="https://danwilliamsforcongress.com/">Homepage</a>
                                </li>
                                <li>
                                    {/* NEW EXTERNAL LINK: Points to the separate video application */}
                                    <a href="https://danwilliamsforcongress.com/videos" onClick={toggleMenu}>Videos</a>
                                </li>
                                <li>
                                    <a href="https://danwilliamsforcongress.com/blog.html">News/Updates</a>
                                </li>
                                <li>
                                   <a href="https://danwilliamsforcongress.com/tech-tools.html">Tech Tools</a>
                                </li>
                            </ul>
                        </nav>
                        <a href="https://danwilliamsforcongress.com/contact-page" className="contact-button">
                            Contact us
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;